// src/utils/googleMapsUtils.js

// Chave do Google Maps usada pelo App (geocode e mapa).
export const GOOGLE_MAPS_API_KEY = 'AIzaSyCftZJ17gqIww9m1mCCtlznA5sXvA536G4';

const CALLBACK_GOOGLE_MAPS = '__infomaioGoogleMapsPronto';
let carregamentoGoogleMaps = null;

// Carrega o Google Maps JavaScript API uma única vez, sob demanda.
export const carregarGoogleMaps = () => {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Mapa indisponível neste ambiente.'));
  }

  if (window.google?.maps?.Map) {
    return Promise.resolve(window.google.maps);
  }

  if (carregamentoGoogleMaps) {
    return carregamentoGoogleMaps;
  }

  carregamentoGoogleMaps = new Promise((resolve, reject) => {
    const falhar = () => {
      carregamentoGoogleMaps = null;
      reject(new Error('Não foi possível carregar o mapa.'));
    };

    window[CALLBACK_GOOGLE_MAPS] = () => {
      delete window[CALLBACK_GOOGLE_MAPS];
      resolve(window.google.maps);
    };

    // Chamado pelo Google quando a chave não tem permissão para o Maps JavaScript API.
    window.gm_authFailure = falhar;

    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js'
      + `?key=${encodeURIComponent(GOOGLE_MAPS_API_KEY)}`
      + `&v=weekly&language=pt-BR&region=BR&callback=${CALLBACK_GOOGLE_MAPS}`;
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      script.remove();
      falhar();
    };
    document.head.appendChild(script);
  });

  return carregamentoGoogleMaps;
};
